import React from 'react'
import { Avatar } from 'primereact/avatar';



// const UserAvatar = ({ name }) => {
  

//   return (
//     <Avatar
//       name={name}
//       size="40" 
//       round={true} 
//       color={randomColor}
//       textSizeRatio={2} // Adjust the size of the text inside the avatar
//     />
//   );
// };

const NameAvatar = ({ name,bgcolor }) => {

    // const randomColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    const firstLetter = name.charAt(0).toUpperCase();
    

  return (
      <span>
          <Avatar round={true}  label={firstLetter} style={{ backgroundColor: `${bgcolor}`, borderRadius:'50%',color: '#ffffff' }} shape="circle" />
    </span>
  )
}

export default NameAvatar